var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FormFieldType, } from '../../../interfaces/createApplication';
var REQUIRED_FIELD_MESSAGE = 'This field is required.';
var isEmptyFieldValue = function (value) {
    if (value === null || value === undefined) {
        return true;
    }
    if (typeof value === 'string') {
        return value.trim() === '';
    }
    return false;
};
var getVisibleFields = function (sections, values) {
    var visibleFields = [];
    sections.forEach(function (section) {
        if (section.isVisible && !section.isVisible(values)) {
            return;
        }
        section.groups.forEach(function (group) {
            if (group.isVisible && !group.isVisible(values)) {
                return;
            }
            group.fields.forEach(function (field) {
                if (field.isVisible && !field.isVisible(values)) {
                    return;
                }
                visibleFields.push(field);
            });
        });
    });
    return visibleFields;
};
export var indexFormFields = function (sections) {
    var fieldsByName = new Map();
    sections.forEach(function (section) {
        section.groups.forEach(function (group) {
            group.fields.forEach(function (field) {
                fieldsByName.set(field.name, field);
            });
        });
    });
    return fieldsByName;
};
var findFieldConfig = function (sections, fieldName) {
    for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
        var section = sections_1[_i];
        for (var _a = 0, _b = section.groups; _a < _b.length; _a++) {
            var group = _b[_a];
            var match = group.fields.find(function (field) { return field.name === fieldName; });
            if (match) {
                return match;
            }
        }
    }
    return undefined;
};
export var validateFormField = function (field, values) {
    if (field.isVisible && !field.isVisible(values)) {
        return '';
    }
    if (field.isDisabled && field.isDisabled(values)) {
        return '';
    }
    var value = values[field.name];
    if (isEmptyFieldValue(value)) {
        return field.isMandatory ? REQUIRED_FIELD_MESSAGE : '';
    }
    return field.validate ? field.validate(value, values) : '';
};
export var validateFormSections = function (sections, values) {
    var errors = {};
    getVisibleFields(sections, values).forEach(function (field) {
        var message = validateFormField(field, values);
        if (message) {
            errors[field.name] = message;
        }
    });
    return errors;
};
export var hasFormErrors = function (errors) {
    return Object.keys(errors).some(function (key) { return Boolean(errors[key]); });
};
export var createInitialFormValues = function (sections, overrides) {
    if (overrides === void 0) { overrides = {}; }
    var values = {};
    sections.forEach(function (section) {
        section.groups.forEach(function (group) {
            group.fields.forEach(function (field) {
                if (field.defaultValue !== undefined) {
                    values[field.name] = field.defaultValue;
                    return;
                }
                values[field.name] = field.type === FormFieldType.CheckBox ? false : '';
            });
        });
    });
    return __assign(__assign({}, values), overrides);
};
